import 'mapbox-gl/dist/mapbox-gl.css';
import TabServiceLines from "./TabServiceLines";
import TabVisitTypes from "./TabVisitTypes";
import TabProviderTypes from "./TabProviderTypes";
import TabShiftCenters from "./TabShiftCenters";
import TabProviderTeams from "./TabProviderTeams";
import TabCancellationReasons from "./TabCancellationReasons";
import TabeSupplyReasons from "./TabSupplyReasons";
import TabClinicalTemplates from "./TabClinicalTemplates";
import TabServices from "./TabServices";
import TabPrecautions from "./TabPrecautions";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { Permission } from "~/hooks/permissions";
import TabsPage from "~/components/layout/TabsPage";
import TabSettings from './TabSettings';
import TabOrganizationalUnits from "./TabOrganizationalUnits";
import TabErrands from "./TabErrands";

const OperateConfig = () => {
  const { loading } = useOrgConfig();

  return <TabsPage basePath="operate-config" loading={loading} tabs={{
    'service-lines': {
      label: 'Service Lines',
      permission: Permission.manageOrgConfig,
      component: (id) => <TabServiceLines id={id} />,
    },
    'organizational-units': {
      label: 'Organizational Units',
      permission: Permission.manageOrgConfig,
      component: () => <TabOrganizationalUnits />,
    },
    'visit-types': {
      label: 'Visit Types',
      permission: Permission.manageOrgConfig,
      component: (id) => <TabVisitTypes id={id} />,
    },
    'errands': {
      label: 'Errands',
      permission: Permission.manageOrgConfig,
      component: (id) => <TabErrands id={id} />,
    },
    'clinical-templates': {
      label: 'Clinical Templates',
      permission: Permission.manageOrgConfig,
      component: (id) => <TabClinicalTemplates id={id} />,
    },
    'services': {
      label: 'Services',
      permission: Permission.manageOrgConfig,
      component: () => <TabServices />,
    },
    'provider-types': {
      label: 'Provider Types',
      permission: Permission.manageOrgConfig,
      component: () => <TabProviderTypes/>,
    },
    'shift-centers': {
      label: 'Shift Centers',
      permission: Permission.manageOrgConfig,
      component: () => <TabShiftCenters />,
    },
    'provider-teams': {
      label: 'Provider Teams',
      permission: Permission.manageOrgConfig,
      component: () => <TabProviderTeams />,
    },
    'cancellation-reasons': {
      label: 'Cancellation Reasons',
      permission: Permission.manageOrgConfig,
      component: () => <TabCancellationReasons />,
    },
    'precautions': {
      label: 'Precautions',
      permission: Permission.manageOrgConfig,
      component: () => <TabPrecautions />,
    },
    'inventory-reasons': {
      label: 'Supply Reasons',
      permission: Permission.debugApps,
      component: () => <TabeSupplyReasons />,
    },
    'settings': {
      label: "Settings",
      permission: Permission.manageOrgConfig,
      component: () => <TabSettings />,
    },
  }}/>
}

export default OperateConfig;
